import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SessionSettingConfiguration } from '../../Models/Models/Session/SessionSettingConfiguration';

declare var IS_RUNNING_IN_APP_POOL;

export class SessionSettingClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<SessionSettingConfiguration, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Session/SessionSetting/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<SessionSettingConfiguration, any>(url, data);
  }
}

